
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter as Router,  Routes ,Route, Navigate, BrowserRouter, useLocation} from 'react-router-dom';
import './App.css'
import 'react-data-grid/lib/styles.css';
import Logout from './Pages/Logout';
import { LoadingFull } from './components/LoadingFull';
import SetHeaders from './components/Functions/SetHeaders';
import { GetDataPromise } from './components/Functions/SendingData';
import AgenciesPage from './Pages/AgenciesPage';
import ToursPage from './Pages/ToursPage';
import LuxintripOperator from './Pages/LuxintripOperator';
import SignupVerify from './Pages/SignupVerify';
import SignInForgetPassword from './Pages/SignInForgetPassword';
import SignInForgetPasswordVerify from './Pages/SignInForgetPasswordVerify';
import TravelAgency from './Pages/TravelAgency';
import TourPage from './Pages/TourPage';
import TourContinentPage from './Pages/TourContinentPage';
import TourCountryPage from './Pages/TourCountryPage';
import Pricing from './Pages/Pricing';
import LuxintripOperatorPages from './Pages/LuxintripOperatorPages';
import BrokerCountryPage from './Pages/BrokerCountryPage';
import BrokerContinentPage from './Pages/BrokerContinentPage';
import BrokerAgenciesPage from './Pages/BrokerAgenciesPage';
import AgencyContinentPage from './Pages/AgencyContinentPage';
import AgencyCountryPage from './Pages/AgencyCountryPage';
import AgencyAgenciesPage from './Pages/AgencyAgenciesPage';
import HotelsPage from './Pages/HotelsPage';
import PaymentSuccess from './Pages/PaymentSuccess';
import BusinessPage from './Pages/BusinessPage';
import BusinessSignInSide from './Pages/BusinessSignInSide';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TourCityPage from './Pages/TourCityPage';
import BuyToursPage from './Pages/BuyToursPage';
import PopupMainPanel from './components/Forms/PopupMainPanel';
import { DictioneryPanel } from './Data/DictioneryPanel';
import { Dictionery } from './Data/Dictionery';
import FormPanLogin from './components/Forms/FormPanLogin';

const Home = lazy(() => import('./Pages/Home'));
const SignInSide = lazy(() => import('./Pages/SignInSide'));
const AdminMain = lazy(() => import('./Pages/Admin/AdminMain'));
const ContactUs = lazy(() => import('./Pages/ContactUs'));
const AboutUs = lazy(() => import('./Pages/AboutUs'));
const Terms = lazy(() => import('./Pages/Terms'));
const InstallApp = lazy(() => import('./Pages/InstallApp'));
const Agencies = lazy(() => import('./Pages/Agencies'));
const Tours = lazy(() => import('./Pages/Tours'));
const BrokerMain = lazy(() => import('./Pages/BrokerAgencies/BrokerMain'));
const AgencyMain = lazy(() => import('./Pages/BrokerAgencies/AgencyMain'));
const UserMain = lazy(() => import('./Pages/BrokerAgencies/UserMain'));
const SignupSide = lazy(() => import('./Pages/SignupSide'));

function App() {
  const [user, setUser] = useState((localStorage.getItem("luxtrip-user")) ? JSON.parse(localStorage.getItem("luxtrip-user")): {});
  const lang = (localStorage.getItem("luxtrip-lang")) ? localStorage.getItem("luxtrip-lang"): "en"
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [dialogCallback, setDialogCallback] = useState({});
  useEffect(() => {
    getData();
  }, [])
  const getData = async(force = false) => {
    setLoading(true);
    if(!user.API_TOKEN){
      return;
    }
    let res = await GetDataPromise(`${apiMain}/api/v1/user/usercheck`, force);
    let parsed = JSON.parse(res);
    if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
      const userdata =  {
        ...parsed.data,
        permission: parsed.permission,
      };
      localStorage.setItem("luxtrip-user", JSON.stringify(userdata));
      setUser(userdata);
      setLoading(false);
      console.log("user data", userdata)
      
      return;
    }
  }
  const defaultProps = {
    user: user,
    setUser: setUser,
    getUserData: getData,
    openLoginDialog: (callback) => {
      if(typeof callback === "function"){
        console.log(callback)
        setDialogCallback((prev) => {
          prev.func = callback
          return {...prev}
        });
      }
      setDialog(true)
    },
  }
  const routes = [
    {
      paths: ["/en", "/fa"],
      componnent: (
        <Home
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/tour-operator", "/fa/tour-operator"],
      componnent: (
        <LuxintripOperator 
          {...defaultProps}
        />
      )
    },
     {
      paths: ["/en/tour-operator/:continent", "/fa/tour-operator/:continent"],
      componnent:
       <BrokerContinentPage
          {...defaultProps} 
        />,
    },

    {
      paths: ["/en/tour-operator/:continent/:country", "/fa/tour-operator/:continent/:country"],
      componnent: (
        <BrokerCountryPage
          {...defaultProps}
        />
      )
    },
    // {
    //   paths: ["/en/tour-operator/:continent?/:country?", "/fa/tour-operator/:continent?/:country?"],
    //   componnent: (
    //     <LuxintripOperatorPages 
    //       {...defaultProps}
    //     />
    //   )
    // },
    {
      paths: ["/en/tour-operator/:continent/:country/:city/:id", "/fa/tour-operator/:continent/:country/:city/:id"],
      componnent: (
        <BrokerAgenciesPage
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/travel-agency", "/fa/travel-agency"],
      componnent: (
        <TravelAgency
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/travel-agency/:continent", "/fa/travel-agency/:continent"],
      componnent:
       <AgencyContinentPage
          {...defaultProps} 
        />,
    },
    {
      paths: ["/en/travel-agency/:continent/:country", "/fa/travel-agency/:continent/:country"],
      componnent: (
        <AgencyCountryPage
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/travel-agency/:continent/:country/:city/:id", "/fa/travel-agency/:continent/:country/:city/:id"],
      componnent: (
        <AgencyAgenciesPage
          {...defaultProps}
        />
      )
    },
    
    {
      paths: ["/en/hotels/:continent/:country/:city/:id", "/fa/hotels/:continent/:country/:city/:id"],
      componnent: (
        <HotelsPage
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/tour/", "/fa/tour/"],
      componnent: (
        <TourPage 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/tour/:continent", "/fa/tour/:continent"],
      componnent: (
        <TourContinentPage 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/tour/:continent/:country", "/fa/tour/:continent/:country"],
      componnent: (
        <TourCountryPage 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/tour/:continent/:country/:city", "/fa/tour/:continent/:country/:city"],
      componnent: (
        <TourCityPage
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/tour/:continent/:country/:city/:id", "/fa/tour/:continent/:country/:city/:id"],
      componnent: (
        <ToursPage 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/buy-tour/:id", "/fa/buy-tour/:id"],
      componnent: (
        <BuyToursPage 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/contactus", "/fa/contactus"],
      componnent: (
        <ContactUs 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/aboutus", "/fa/aboutus"],
      componnent: (
        <AboutUs 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/terms", "/fa/terms"],
      componnent: (
        <Terms 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/pricing", "/fa/pricing"],
      componnent: (
        <Pricing
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/business", "/fa/business"],
      componnent: (
        <BusinessPage
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/business-login", "/fa/business-login"],
      componnent: (
        <BusinessSignInSide
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/installapp", "/fa/installapp"],
      componnent: (
        <InstallApp 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/privacy-policy", "/fa/privacy-policy"],
      componnent: (
        <PrivacyPolicy 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/login", "/fa/login"],
      componnent: (
        <SignInSide 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/signup", "/fa/signup"],
      componnent: (
        <SignupSide 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/signup-verify", "/fa/signup-verify"],
      componnent: (
        <SignupVerify
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/forget-password", "/fa/forget-password"],
      componnent: (
        <SignInForgetPassword 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/forget-password-verify", "/fa/forget-password-verify"],
      componnent: (
        <SignInForgetPasswordVerify 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/payment/final", "/fa/payment/final"],
      componnent: (
        <PaymentSuccess 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/admin/:path1?/:path2?/:path3?/:path4?"],
      componnent: (
        <AdminMain 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/broker-panel/:path1?/:path2?/:path3?/:path4?", "/fa/broker-panel/:path1?/:path2?/:path3?/:path4?"],
      componnent: (
        <BrokerMain 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/agency-panel/:path1?/:path2?/:path3?/:path4?", "/fa/agency-panel/:path1?/:path2?/:path3?/:path4?"],
      componnent: (
        <AgencyMain 
          {...defaultProps}
        />
      )
    },
    {
      paths: ["/en/profile/:path1?/:path2?/:path3?", "/fa/profile/:path1?/:path2?/:path3?"],
      componnent: (
        <UserMain 
          {...defaultProps}
          getDataUser={getData}
        />
      )
    },
    
    
    {
      paths: ["/en/logout", "/fa/logout"],
      componnent: (
        <Logout
          {...defaultProps}
        />
      )
    },
  ]
  const routesComp = routes.map((route, i) => {
    let items = route.paths.map((path, ii) => {
        return (
        <Route 
          key={i+"-"+ii}
          path={path}
          Component={() => route.componnent}
        >
        </Route>
      )
    })
    return items
  });

  return(
    <Suspense fallback={<LoadingFull/>}>
      <Router>
        <SetHeaders/>
        <Routes>
          {routesComp}
          <Route path='*' Component={() => <NotFoundRedirect lang={lang}/>}/>
        </Routes>
      </Router>
      <PopupMainPanel
        title={Dictionery.loginSignup[lang]}
        open={dialog}
        close={() => {setDialog(false);}}
        lang={lang}
      >
        <FormPanLogin 
          {...defaultProps}
          dialogCallback={dialogCallback}
          setDialogCallback={setDialogCallback}
          save={() => {
            setDialog(false);
            getData(true);
          }} 
          lang={lang}
        />
      </PopupMainPanel>
    </Suspense>
  )
}
function NotFoundRedirect ({lang = "en"}) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  if(searchParams.get("invite")){
    localStorage.setItem("luxintrip-invite-code", searchParams.get("invite"))
  }
  if(location.pathname.search("/en") !== -1 || location.pathname.search("/fa") !== -1){
    return <Navigate to={"/" + lang}/>
  }
  if(location.pathname === "/"){
    return <Navigate to={"/" + lang}/>
  }
  return <Navigate to={"/" + lang + "" + location.pathname + location.search}/>
}
export const apiMain = process.env.REACT_APP_API

export default App;

